function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Controller as e } from "stimulus";

var t = /*#__PURE__*/function (_e) {
  _inherits(t, _e);

  var _super = _createSuper(t);

  function t() {
    _classCallCheck(this, t);

    return _super.apply(this, arguments);
  }

  _createClass(t, [{
    key: "connect",
    value: function connect() {
      this.hasUrlValue ? this.hasLazyLoadingValue ? this.lazyLoad() : this.load() : console.error("[stimulus-content-loader] You need to pass an url to fetch the remote content.");
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      this.stopRefreshing();
    }
  }, {
    key: "load",
    value: function load() {
      this.fetch(), this.hasRefreshIntervalValue && this.startRefreshing();
    }
  }, {
    key: "lazyLoad",
    value: function lazyLoad() {
      var _this = this;

      var e = {
        threshold: this.lazyLoadingThresholdValue,
        rootMargin: this.lazyLoadingRootMarginValue || "0px"
      };
      new IntersectionObserver(function (e, _t) {
        e.forEach(function (e) {
          e.isIntersecting && (_this.load(), _t.unobserve(e.target));
        });
      }, e).observe(this.element);
    }
  }, {
    key: "fetch",
    value: function (_fetch) {
      function fetch() {
        return _fetch.apply(this, arguments);
      }

      fetch.toString = function () {
        return _fetch.toString();
      };

      return fetch;
    }(function () {
      var _this2 = this;

      fetch(this.urlValue).then(function (e) {
        return e.text();
      }).then(function (e) {
        _this2.element.innerHTML = e, _this2.loadScriptsValue && _this2.loadScripts();
      });
    })
  }, {
    key: "startRefreshing",
    value: function startRefreshing() {
      var _this3 = this;

      this.refreshTimer = setInterval(function () {
        _this3.fetch();
      }, this.refreshIntervalValue);
    }
  }, {
    key: "stopRefreshing",
    value: function stopRefreshing() {
      this.refreshTimer && clearInterval(this.refreshTimer);
    }
  }, {
    key: "loadScripts",
    value: function loadScripts() {
      this.element.querySelectorAll("script").forEach(function (e) {
        var _t2 = document.createElement("script");

        _t2.innerHTML = e.innerHTML, document.head.appendChild(_t2).parentNode.removeChild(_t2);
      });
    }
  }]);

  return t;
}(e);

t.values = {
  url: String,
  lazyLoading: Boolean,
  lazyLoadingThreshold: Number,
  lazyLoadingRootMargin: String,
  refreshInterval: Number,
  loadScripts: Boolean
};
export default t;